module.exports = __webpack_public_path__ + "3d7d4858ae926cc63ee79b0af4c531e0.MP3";